import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.643 11.137a.5.5 0 0 1-1 0zm-.5-1.929h-.5zM5.677 7.78a.5.5 0 1 1 0-1zm-4.821.643a.5.5 0 0 1 0-1zm2.893-1a.5.5 0 0 1 0 1zm-.947 1.946a.5.5 0 1 1-1 0zm-1-2.893a.5.5 0 0 1 1 0zM4.714 2.78h.5c0 .79.64 1.429 1.429 1.429v1A2.43 2.43 0 0 1 4.214 2.78zM6.643 4.71v-.5c.789 0 1.428-.64 1.428-1.429h1A2.43 2.43 0 0 1 6.643 5.21zM8.57 2.78h-.5c0-.789-.64-1.428-1.428-1.428v-1A2.43 2.43 0 0 1 9.07 2.78zM6.643.852v.5c-.79 0-1.429.64-1.429 1.428h-1A2.43 2.43 0 0 1 6.643.352zm4.5 10.285h-.5V9.21h1v1.928zM9.213 7.28v-.5a2.43 2.43 0 0 1 2.43 2.428h-1c0-.788-.64-1.428-1.43-1.428zm0 0v.5H5.679v-1h3.536zm-8.356.643v-.5h1.446v1H.857zm1.446 0v-.5H3.75v1H2.303zm0 1.446h-.5V7.923h1v1.446zm0-1.446h-.5V6.476h1v1.447z"
    }, null, -1)
  ]))]))
}
export default { render: render }